export function createYjsHistoryActions(getUndoManager) {
  const getManager = typeof getUndoManager === 'function'
    ? getUndoManager
    : () => null;

  return {
    undo() {
      getManager()?.undo();
    },

    redo() {
      getManager()?.redo();
    },

    canUndo() {
      const manager = getManager();
      return !!(
        manager
        && Array.isArray(manager.undoStack)
        && manager.undoStack.length > 0
      );
    },

    canRedo() {
      const manager = getManager();
      return !!(
        manager
        && Array.isArray(manager.redoStack)
        && manager.redoStack.length > 0
      );
    },
  };
}
